/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface FormateursMetiersAgrementSearch
 */
export interface FormateursMetiersAgrementSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateursMetiersAgrementSearch
     */
    idformateurAgrement?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormateursMetiersAgrementSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormateursMetiersAgrementSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateursMetiersAgrementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateursMetiersAgrementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateursMetiersAgrementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateursMetiersAgrementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateursMetiersAgrementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateursMetiersAgrementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateursMetiersAgrementSearch interface.
 */
export function instanceOfFormateursMetiersAgrementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateursMetiersAgrementSearchFromJSON(json: any): FormateursMetiersAgrementSearch {
    return FormateursMetiersAgrementSearchFromJSONTyped(json, false);
}

export function FormateursMetiersAgrementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateursMetiersAgrementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateurAgrement': !exists(json, 'idformateurAgrement') ? undefined : json['idformateurAgrement'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateursMetiersAgrementSearchToJSON(value?: FormateursMetiersAgrementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateurAgrement': value.idformateurAgrement,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

